/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
/* eslint-disable implicit-arrow-linebreak */
// https://hackernoon.com/shape-your-redux-store-like-your-database-98faa4754fd5

// categories: {
//   '32o8wafe': {id: '32o8wafe', name: 'abs',  exercises: [...]},
//   'oaiwefjo': {id: 'oaiwefjo', name: 'arms', exercises: [...]},
//   '3oij2e3c': {id: '3oij2e3c', name: 'legs', exercises: [...]},
// }

// index_by_name object with the above scheme
export const $ibn = categories =>
  Object.values(categories)
    // eslint-disable-next-line no-sequences
    .reduce((obj, row) => (obj[row.name] = row.id, obj), {});

/** use counter as a unique id generator for client */
export const IdGen = function* fn() {
  let count = 0;
  while (true) {
    count += 1;
    yield count;
  }
};
